var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsString } from 'class-validator';
import { Heilmittelbereich } from '../../pvs-billing/enums/heilmittelbereich.enum.js';
/**
 * Which Heilmittelbereich the practice is set up for at an OfficeLocation, and
 * under which IK — the part of a Leistungserbringer that is printed on every
 * Verordnung anyway (Feld „IK des Leistungserbringers"). Readable by everyone
 * who works at the location, unlike the full {@link LeistungserbringerResponseDto}:
 * the Abrechnungscode and the §302 participation stay kaufmännische Stammdaten.
 */
export class LeistungserbringerIkResponseDto {
    heilmittelbereich;
    /** Nine digits, no separators. */
    ik;
}
__decorate([
    Expose(),
    IsEnum(Heilmittelbereich),
    __metadata("design:type", String)
], LeistungserbringerIkResponseDto.prototype, "heilmittelbereich", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], LeistungserbringerIkResponseDto.prototype, "ik", void 0);
//# sourceMappingURL=leistungserbringer-ik.response.dto.js.map